export default __webpack_public_path__ + "static/media/messenger.379890f0.png";